import { render, staticRenderFns } from "./LetterViewerModal.vue?vue&type=template&id=3127a926&"
import script from "./LetterViewerModal.vue?vue&type=script&lang=js&"
export * from "./LetterViewerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports